import { Injectable, inject } from '@angular/core';;
import { ApiService } from '../../Modules/Shared/Services/api.service';
import { endpoints } from '../../../environments/endpoints';
import { HttpResourceRequest } from '@angular/common/http';
import { IndexPayload } from '../../Interfaces/api/Intune/search.interface';
import { IndexResponse } from '../../Interfaces/api/roles.interface';

@Injectable({
    providedIn: 'root',
})
export class SearchService {
    private _apiService = inject(ApiService);

    index<T>(searchTerm: string, payload: IndexPayload, skipLoading: boolean = true): HttpResourceRequest {
        return this._apiService.get<IndexResponse>(endpoints.api.intune.search.index(searchTerm), { params: payload as Record<string, string>, skipLoading });
    }
}